@if (displayTitle()) {
  <div class="invitation-channel-heading">Envoyer l’invitation par</div>
}
<div class="invitation-channel-container">
  <tiime-checkbox-card
    data-cy="email-channel-checkbox-card"
    [(ngModel)]="email"
    (ngModelChange)="toggleChannel()"
    [disabled]="disabled()"
  >
    @if (displayIcons()) {
      <div cardHeader>
        <tiime-twocolors-icon class="tiime-toggle-icon" icon="ic_twocolors_mail" size="24"></tiime-twocolors-icon>
      </div>
    }
    <div cardDescription>Email</div>
  </tiime-checkbox-card>
  <tiime-checkbox-card
    data-cy="sms-channel-checkbox-card"
    [(ngModel)]="sms"
    (ngModelChange)="toggleChannel()"
    [disabled]="disablePhoneInput()"
  >
    @if (displayIcons()) {
      <div cardHeader>
        <tiime-twocolors-icon class="tiime-toggle-icon" icon="ic_twocolors_smartphone" size="24"></tiime-twocolors-icon>
      </div>
    }
    <div cardDescription>SMS</div>
  </tiime-checkbox-card>
</div>
@if (!isMobilePhoneNumber()) {
  <tiime-alert data-cy="invitation-channel-warning" primary>
    Vous devez d'abord ajouter un numéro de téléphone mobile à votre contact pour l'inviter par SMS.
  </tiime-alert>
}
